import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, View } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { poll_getLeadersByCampaignId } from '../../../store/actionsv1/polls';
import { PollCampaignLeaderProps } from '../../../store/types/auth_svc';
import LeaderCard from '../../Brackets/BracketComponents/LeaderCard';
import { poll_leaders_getPlace } from '../helpers/poll_leaders';

type PollCampaignLeaderboardProps = {
    poll_campaign_id:string,
    hide_title?:boolean
}

const PollCampaignLeaderboard = ({ poll_campaign_id, hide_title }:PollCampaignLeaderboardProps) => {
    const [ loading, setLoading ] = useState(false);
    const [ leaders_offset, setLeadersOffset ] = useState(0);

    const dispatch = useDispatch();
    const poll_campaign_leaders_list:{ updated:number, poll_campaign_leaders:PollCampaignLeaderProps[] } = useSelector((state:any) => state.poll.poll_campaign_leaders_list, (left, right) => left.updated == right.updated);
    const { poll_campaign_leaders } = poll_campaign_leaders_list;

    let filtered_leaders = poll_leaders_getPlace(poll_campaign_leaders)
    filtered_leaders = filtered_leaders.filter((cl, index) => index < leaders_offset * 10 && (index + 1) > (leaders_offset - 1) * 10)



    useEffect(() => {
        getLeadersFromServer(leaders_offset)
    },[poll_campaign_id])

    const getLeadersFromServer = async(offset:number) => {
        setLoading(true);
        await dispatch(poll_getLeadersByCampaignId(poll_campaign_id, offset))
        setLeadersOffset(offset + 1)
        setLoading(false);
    }

    const renderLeaders = (data: {item:PollCampaignLeaderProps, index:number}) => {
        return (
            <LeaderCard
                player_id={data.item.player_id}
                place={data.item.place}
                score_description={`${data.item.responses} responses`}
                winnings_label={`E${data.item.winnings.toFixed(2)}`}
                onLeaderSelect={(player_id) => console.log(player_id)}
            />
        )
    }

    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white, padding:5, borderRadius:8 }}>
            {!hide_title ?
                <Text style={{ margin:10 }} size={18} textAlign='center' color={Colors.brand.midnight} weight='semibold'>Leaderboard</Text>
            :<></>}
            <FlatList
                data={filtered_leaders.sort((a,b) => b.winnings - a.winnings)}
                renderItem={renderLeaders}
                />
            {loading ?
            <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight}/>
            </View>
            :<></>}
            <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between', padding:10, marginTop:5 }}>
                {leaders_offset > 1 ?
                <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }} onPress={() => setLeadersOffset(leaders_offset - 1)}>
                    <Icon name='chevron-left' type='feather' color={Colors.brand.electric} size={14}/>
                    <Text style={{ marginLeft:5 }} size={14} color={Colors.brand.electric} weight='regular'>Prev</Text>
                </TouchableOpacity>
                :
                <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }} onPress={() => window.open('https://support.bettoredge.com/hc/en-us/articles/14851201619095', '_blank')}>
                    <Icon name='alert-circle' type='feather' color={Colors.brand.electric} size={14}/>
                    <Text style={{ marginLeft:5 }} size={14} color={Colors.brand.electric} weight='regular'>Learn More</Text>
                </TouchableOpacity>
                }
                <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }} onPress={() => getLeadersFromServer(leaders_offset)}>
                    <Text style={{ marginRight:5 }} size={14} color={Colors.brand.electric} weight='regular'>Next</Text>
                    <Icon name='chevron-right' type='feather' color={Colors.brand.electric} size={14}/>
                </TouchableOpacity>
            </View>
        </View>
    )
}

export default PollCampaignLeaderboard